<template>
	<div v-if="selectedStudy && currentTab" class="TrackRecalls">
		<h2 v-if="selectedStudy.recallType" class="left-align">Track Recalls</h2>
		<h2 v-if="selectedStudy.recordStudyType" class="left-align">Track Records</h2>
		<div class="track-recalls-filter-container">
			<v-row>
				<v-col>
					<v-row no-gutters>
						<v-col>
							<p class="p3 left-align"><label>Filter by username</label></p>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col>
							<v-text-field
								ref="firstFocusable"
								outlined
                placeholder="Username"
                single-line
                hide-details
                v-model="filterUserNameValue"
								v-on:keyup.enter="runSearch"
								:aria-label="'Filter by username: ' + filterUserNameValue"
            ></v-text-field>
						</v-col>
					</v-row>
				</v-col>
				<v-divider vertical></v-divider>
				<v-col>
					<v-row no-gutters>
						<v-col md="6" >
							<p class="p3 left-align">Start Date</p>
							<v-menu  v-model="startDateMenu" :close-on-content-click="false" offset-y tile allow-overflow>
  							<template v-slot:activator="{ on, attrs }">
								<v-text-field
								hide-details="auto"
								outlined
								type="date"
								:rules="startDateRules"
								v-model="filterStartDateValue"
								id="track-recalls-startdate"
								v-bind="attrs"
      					v-on="on"
								@keydown.tab='startDateMenu = false'
								:aria-label="'Start Date: ' + filterStartDateValue"
								v-on:keyup.enter="runSearch"
							>
							</v-text-field>
								</template>
								<v-date-picker v-model="filterStartDateValue" color="#42729B" style="margin: 0px; float: left" @input="startDateMenu = false"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col md="6" >
							<p class="p3 left-align">End Date</p>
							<v-menu  v-model="endDateMenu" :close-on-content-click="false" offset-y tile allow-overflow>
  							<template v-slot:activator="{ on, attrs }">
								<v-text-field
								hide-details="auto"
								outlined
								type="date"
								:rules="endDateRules"
								v-model="filterEndDateValue"
								id="track-recalls-enddate"
								v-bind="attrs"
      					v-on="on"
								@keydown.tab='endDateMenu = false'
								:aria-label="'End Date: ' + filterEndDateValue"
								v-on:keyup.enter="runSearch"
							>
							</v-text-field>
								</template>
								<v-date-picker v-model="filterEndDateValue" color="#42729B" style="margin: 0px; float: left" @input="endDateMenu = false"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
				<v-divider vertical></v-divider>
				<v-col>
					<v-row no-gutters>
						<v-col>
							<p class="p3 left-align">Status</p>
						</v-col>
					</v-row>

					<fieldset class="border-0">
						<legend class="d-sr-only">
							Status
						</legend>

						<v-row no-gutters>
							<v-col>
								<v-checkbox v-model="completedFilter"
														:label="'Completed'"></v-checkbox>
							</v-col>
							<v-col>
								<v-checkbox v-model="quitFilter"
														:label="'Quit'"></v-checkbox>
							</v-col>
							<v-col>
								<v-btn @click="runSearch()" class="btn-default btn-search" text>Search</v-btn>
								<v-btn @click="clearFilters()" class="btn-default btn-search" text>Clear</v-btn>
							</v-col>
						</v-row>

					</fieldset>

				</v-col>
			</v-row>
		</div>
		<p v-if="selectedStudy.recordStudyType" class="track-extra-info left-align">The table below displays individual days within records. The Record # and Record Day # fields can be used to distinguish each day. The column Completion Status indicates “completed” or “quit” for each day of within a record. Only if all days within the record are “completed”, will the Completed Records column under the Track Respondents tab indicate the record is completed at the individual level.</p>
		<br v-if="selectedStudy.recordStudyType">
		<v-btn class="btn-link text-none" text @click="selectAll()">Select All</v-btn>
    <v-btn class="btn-link text-none" text @click="deselectAll()">Deselect All</v-btn>
		<vue-json-to-csv
      :json-data="selected"
      :csv-title="'selected-recalls'"
    >
      <v-btn :disabled="this.selected.length == 0" class="btn-link text-none" text>Export Selected</v-btn>
    </vue-json-to-csv>
    <vue-json-to-csv
      :json-data="recallsResults.recalls"
      :csv-title="'all-recalls'"
    >
      <v-btn class="btn-link text-none" text>Export Page</v-btn>
    </vue-json-to-csv>
		<v-btn
			class="btn-link text-none"
			text
			:disabled="this.selected.length == 0"
			@click="onDeleteSelectedRecallsClick()"
		>
				Delete Selected
			</v-btn>
		<div v-show="headers.length !== 0" class="track-recalls-table-container">
			<v-data-table
				v-model="selected"
				:loading="isRecallsLoading"
				:headers="headers"
				:items="recallsResults.recalls"
				item-key="recallId"
				show-select
				class="elevation-1"
				:server-items-length="recallsResults.total"
				:options.sync="dataTableOptions"
				@update:options="onUpdateOptions"
				:page.sync="dataTableOptions.page"
				hide-default-footer
			>
				<template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
					<v-tooltip  :disabled="h.hover === ''" :key="h.value" bottom color="#333">
						<template v-slot:activator="{ on }">
							<span v-on="on" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}} <span class="d-sr-only">({{h.hover}})</span></span>
						</template>
						<span>{{h.hover}}</span>
					</v-tooltip>
				</template>
				<!-- for the check box header -->
				<template v-slot:header.data-table-select="{ value, selected }">
					<v-checkbox
            :value="value"
            :selected="selected"
						aria-label="select all"
            hide-details
            class="mt-0"
						@change="checkboxHeader"
					>
					</v-checkbox>
				</template>
				<!-- for the check boxes -->
				<template v-slot:item.data-table-select="{ item, isSelected }">
					<v-checkbox
						:value="isSelected"
            :isSelected="item"
						aria-label="record"
            hide-details
            class="mt-0"
						@change="checkboxData(item)"
						>
					</v-checkbox>
				</template>
				<template v-slot:item.dateReported="{ item }">
					{{ getFormattedDate(item.dateReported) }}
				</template>
				<template v-slot:item.kCal="{ item }">
					{{ (item.kCal).toFixed(3) }}
				</template>
			</v-data-table>
			<div class="pagination-container">
				<v-row>
					<v-col :cols="2">
						<v-text-field
							:value="dataTableOptions.itemsPerPage"
							label="Items per page"
							type="number"
							:min="minItemsPerPage"
							:max="maxItemsPerPage"
							@input="onItemsPerPageTextInput"
						></v-text-field>
					</v-col>
					<v-col :cols="10">
						<v-pagination
							v-model="dataTableOptions.page"
							:total-visible="7"
							:length="pageCount"
						></v-pagination>
					</v-col>
				</v-row>
			</div>
		</div>
		<!-- Delete confirmation pop up -->
		<foe-dialog
      v-model="showDeleteSelectedRecallsModal"
			:dialogW="showDeleteSelectedRecallsModal"
      max-width="600"
			class="delete-study-dialog"
    >
      <v-card class="study-delete-confirm-card">
        <v-card-title class="headline">
          {{ deleteConfirmHeader }}
        </v-card-title>
        <v-card-text>
					<p class="p2 left-align">
						{{ deleteConfirmBody }}
						<br><br>
						<strong>This action cannot be undone.</strong> Proceed?
					</p>
				</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
						class="btn-default"
            @click="showDeleteSelectedRecallsModal = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
						class="btn-default"
						:loading="loadingDeleteSelectedRecalls"
            @click="deleteSelectedRecalls()"
          >
            <v-icon >delete</v-icon>{{  deleteConfirmButton }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
	</div>
</template>

<script>
import { analysisApiService } from '@/services/analysisApiService.js';
import { researcherApiService } from '@/services/researcherApiService.js';
import VueJsonToCsv from 'vue-json-to-csv';
import { utilityService } from '@/services/utilityService.js';
import { RecallStatus } from '@/common/RecallStatus.js';
export default {
	name: 'TrackRecalls',
	components: { VueJsonToCsv },
	data: () => ({
		selected: [],
		recallsResults: {
			recalls: [],
			total: 0
		},
		minItemsPerPage: 1,
		maxItemsPerPage: 25,
		page: 1,
		itemsPerPage: 25,
		filterStartDateValue: null,
		filterEndDateValue: null,
		filterUserNameValue: '',
		completedFilter: false,
		quitFilter: false,
		studyUuid: '',
		isRecallsLoading: false,
		showDeleteSelectedRecallsModal: false,
		loadingDeleteSelectedRecalls: false,
		startDateRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		endDateRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		startDateMenu: false,
		endDateMenu: false,
		dataTableOptions: {
			sortBy: ['userName'],
			sortDesc: [false],
			page: 1,
			itemsPerPage: 15
		}
	}),
	mounted () {
		this.endDateRules.push(v => v >= this.filterStartDateValue || 'Date must be greater than or equal to the start date');
	},
	computed: {
		headers: function () {
			let array = []
			if (this.selectedStudy.recallType) {
				array = [
					{ text: 'Username', value: 'userName', hover: '', class: 'data-table-header', align: 'center' },
					{ text: 'Recall #', value: 'recallNo', hover: '', class: 'data-table-header', align: 'center' },
					{ text: 'Reporting Date', value: 'dateReported', hover: 'The date the respondent reported the intake.', class: 'data-table-header', filter: this.filterDate, align: 'center' },
					{ text: 'Completion Status', value: 'recallStatus', hover: 'The end of the report was reached and the usual intake question* answered.', class: 'data-table-header', filter: this.filterStatus, align: 'center' },
					{ text: 'Total Sessions', value: 'numSessions', hover: 'The number of times a respondent logged in to complete a recall.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Total Session Duration', value: 'totalSessionDurationMin', hover: 'Total number of minutes a respondent spent completing a recall totaled across one or multiple sessions.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Language', value: 'language', hover: 'Language respondent selected to complete the recall.', class: 'data-table-header', align: 'center' },
					{ text: 'Calories (kCal)', value: 'kCal', hover: 'Total number of calories of foods and drinks reported.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Number of Eating Occasions', value: 'numMeals', hover: 'Total number of meals reported.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Number of Food Codes', value: 'numFoodCodes', hover: 'Total number of different food codes reported.', class: 'data-table-header', align: 'center', sortable: false }
				]
			} else if (this.selectedStudy.recordStudyType) {
				array = [
					{ text: 'Username', value: 'userName', hover: '', class: 'data-table-header', align: 'center' },
					{ text: 'Record #', value: 'recordNo', hover: '', class: 'data-table-header', align: 'center' },
          { text: 'Reporting Date', value: 'dateReported', hover: 'The date the respondent reported the intake.', class: 'data-table-header', filter: this.filterDate, align: 'center' },
					{ text: 'Completion Status', value: 'recallStatus', hover: 'The end of the report was reached and the usual intake question* answered.', class: 'data-table-header', filter: this.filterStatus, align: 'center' },
					{ text: 'Total Sessions', value: 'numSessions', hover: 'The number of times a respondent logged in to complete a recall.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Total Session Duration', value: 'totalSessionDurationMin', hover: 'Total number of minutes a respondent spent completing a recall totaled across one or multiple sessions.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Language', value: 'language', hover: 'Language respondent selected to complete the recall.', class: 'data-table-header', align: 'center' },
					{ text: 'Calories (kCal)', value: 'kCal', hover: 'Total number of calories of foods and drinks reported.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Number of Eating Occasions', value: 'numMeals', hover: 'Total number of meals reported.', class: 'data-table-header', align: 'center', sortable: false },
					{ text: 'Number of Food Codes', value: 'numFoodCodes', hover: 'Total number of different food codes reported.', class: 'data-table-header', align: 'center', sortable: false }
				];

        // If the record study is consecutive, add the record day # column
        if (this.selectedStudy.recordStudyType === this.$createStudyLists.RECORD_TYPE_CONSECUTIVE.value) {
          array.splice(2, 0, { text: 'Record Day #', value: 'recordDayNo', hover: '', class: 'data-table-header', align: 'center' });
        }
			}
			return array
		},
		selectedStudy: function () {
			// If the selectedStudy changes, the radio buttons and checkbox properties need to be updated.
			if (this.studyUuid !== this.$store.getters.getSelectedStudy.studyUuid) {
				this.updateSelected();
			}
			return this.$store.getters.getSelectedStudy;
		},
		currentTab: function () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};

			this.checkTabMatch(tabPosition);

			return tabPosition;
		},
		pageCount: function () {
			if (this.dataTableOptions) {
				return this.calculatePageCount(this.dataTableOptions.itemsPerPage);
			}
			return 0;
		},
    /**
     * Returns the header for the delete confirm dialog
     */
    deleteConfirmHeader: function () {
      // Modify the header based on the study type
      let isRecord = this.selectedStudy.recordStudyType;
      if (isRecord) {
        return "Confirm Delete Record(s)";
      }
      return "Confirm Delete Recall(s)";
    },
    /**
     * Returns the body for the delete confirm dialog
     */
    deleteConfirmBody: function () {
      // Modify the body based on the study type
      let isRecord = this.selectedStudy.recordStudyType;
      let isConsecutiveRecord = this.selectedStudy.recordStudyType === this.$createStudyLists.RECORD_TYPE_CONSECUTIVE.value;
      if (isRecord && !isConsecutiveRecord) {
        return "Are you sure you want to delete the selected record(s)? All record data will be removed.";
      }
      else if (isRecord && isConsecutiveRecord) {
        return "Are you sure you want to delete the selected record(s)? All record days within selected records will be removed.";
      }
      return "Are you sure you want to delete the selected recall(s)?  All recall data will be removed.";
    },
    /**
     * Returns the button text for the delete confirm dialog
     */
    deleteConfirmButton: function () {
      let isRecord = this.selectedStudy.recordStudyType;
      if (isRecord) {
        return "Delete Record(s)";
      }
      return "Delete Recall(s)";
    }
	},
	methods: {
		checkboxHeader (e) {
			if (e) {
				this.selectAll()
			} else {
				this.deselectAll()
			}
		},
		checkboxData (obj) {
			if (!this.selected.includes(obj)) {
				this.selected.push(obj)
			} else {
				for (var i = this.selected.length; i--;) {
					if (this.selected[i] === obj) this.selected.splice(i, 1);
				}
			}
		},
		/**
		 * Handles the manual typing of the page size event
		 * @param {*} event - The raised event that holds the entered page size
		 */
		onItemsPerPageTextInput: function (event) {
			let parsedItemsPerPage = parseInt(event, 10);
			if (!isNaN(parsedItemsPerPage)) {
				// If the entered page size is greater than the total number of recalls, set the page size to the total number of recalls
				if (parsedItemsPerPage > this.maxItemsPerPage) {
					parsedItemsPerPage = this.maxItemsPerPage;
				}

				// If the entered page size is less than the minimum page size, set the page size to the minimum page size
				if (parsedItemsPerPage < this.minItemsPerPage) {
					parsedItemsPerPage = this.minItemsPerPage;
				}

				// If the items per page is increasing there's a possibility the selected page is out of range
				if (parsedItemsPerPage > this.dataTableOptions.itemsPerPage) {
					// if it is out of range shift the value to the last page of the new count
					const newPageCount = this.calculatePageCount(parsedItemsPerPage);
					if (this.dataTableOptions.page > newPageCount) {
						this.dataTableOptions.page = newPageCount;
					}
				}

				this.dataTableOptions.itemsPerPage = parsedItemsPerPage;
			}
		},
		onUpdateOptions: function () {
			this.loadData();
		},
		updateSelected () {
			this.studyUuid = this.$store.getters.getSelectedStudy.studyUuid;
			this.loadData();
		},
		async loadData () {
			var rawRecalls;
			this.isRecallsLoading = true;
			const me = this;

			// Handle setting a default sort field if not picked
			let sortBy = 'userName';
			if (this.dataTableOptions.sortBy != null && this.dataTableOptions.sortBy.length > 0) {
				sortBy = this.dataTableOptions.sortBy[0];
			}

			const page = this.dataTableOptions.page;
			const pageSize = this.dataTableOptions.itemsPerPage;
			const sortDir = this.dataTableOptions.sortDesc[0] ? 'DESC' : 'ASC';

			// Create an array of recall statuses
			let recallStatuses = [];
			if (this.completedFilter || this.quitFilter) {
				if (this.completedFilter) {
					recallStatuses.push(RecallStatus.Completed);
				}
				if (this.quitFilter) {
					recallStatuses.push(RecallStatus.Quit);
				}
			} else {
				recallStatuses = null;
			}

			await analysisApiService.loadRecalls(this.selectedStudy.studyId, page, pageSize, sortBy, sortDir, this.filterUserNameValue, this.filterStartDateValue, this.filterEndDateValue, recallStatuses)
				.then(async function (response) {
					if (response && response.data) {
						rawRecalls = response.data.trackDataList;
						me.recallsResults.total = response.data.totalResults;
					}
					me.isRecallsLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					me.recallsResults.total = 0;
					me.isRecallsLoading = false;
				});
			this.recallsResults.recalls = this.translateEnums(rawRecalls);
		},
		async checkTabMatch ({ tabIndex, subTabIndex } = {}) {
			var tabsPos = await utilityService.getTabsPositionByName('Track Recalls', this.$studyTabConfig);
			if (tabsPos.tabPos === tabIndex && tabsPos.subtabPos === subTabIndex) {
				this.$refs.firstFocusable.focus();
				this.loadData();
			}
		},
		filterStatus (val) {
			if (!this.completedFilter && !this.quitFilter) {
				return true;
			}

			if (this.completedFilter && this.quitFilter) {
				return true;
			}

			if (this.completedFilter) {
				return val.toLowerCase().includes('completed');
			}

			if (this.quitFilter) {
				return val.toLowerCase().includes('quit');
			}
		},
		filterDate (val) {
			if (!this.filterStartDateValue && !this.filterEndDateValue) {
				return true;
			}

			const selectedStartDate = new Date(this.filterStartDateValue + 'T00:00:00Z').getTime();
			const selectedEndDate = new Date(this.filterEndDateValue + 'T00:00:00Z').getTime() + 86399999; // adding 1 less millisecond of 24 hours of milliseconds (86400000) is essentially the 'end' timestamp for that date's range of miliseconds
			const recallDate = new Date(val).getTime();

			if (this.filterStartDateValue && this.filterEndDateValue) {
				return (recallDate <= selectedEndDate ? (recallDate >= selectedStartDate) : false);
			}

			if (this.filterStartDateValue) {
				return recallDate >= selectedStartDate;
			}

			if (this.filterEndDateValue) {
				return recallDate <= selectedEndDate;
			}
		},
		clearFilters () {
			const selectedStartDate = new Date(this.filterStartDateValue + 'T00:00:00Z').getTime();
			console.log('this.filterStartDateValue', this.filterStartDateValue)
			console.log('selectedStartDate', selectedStartDate)
			const selectedEndDate = new Date(this.filterEndDateValue + 'T00:00:00Z').getTime();
			console.log('this.filterEndDateValue', this.filterEndDateValue)
			console.log('selectedEndDate', selectedEndDate)

			this.filterUserNameValue = '';
			this.completedFilter = false;
			this.quitFilter = false;
			this.filterStartDateValue = null;
			this.filterEndDateValue = null;

			this.loadData();
		},
		runSearch () {
			// When running a new search, reset the page to 1
			this.dataTableOptions.page = 1;
			this.loadData();
		},
		translateEnums (rawRecalls) {
			for (var i = 0; i < rawRecalls.length; i++) {
				switch (parseInt(rawRecalls[i].language)) {
				case 0:
					rawRecalls[i].language = 'Unknown';
					break;
				case 1:
					rawRecalls[i].language = 'English';
					break;
				case 2:
					rawRecalls[i].language = 'Spanish';
					break;
				case 3:
					rawRecalls[i].language = 'French';
					break;
				case 4:
					rawRecalls[i].language = 'Polish';
					break;
				}
				switch (rawRecalls[i].recallStatus) {
				case 5:
					rawRecalls[i].recallStatus = 'Quit';
					break;
				case 2:
					rawRecalls[i].recallStatus = 'Completed';
					break;
				}
			}

			return rawRecalls;
		},
		selectAll () {
			this.selected = this.recallsResults.recalls;
		},
		deselectAll () {
			this.selected = [];
		},
		onDeleteSelectedRecallsClick () {
			this.showDeleteSelectedRecallsModal = true;
		},
		deleteSelectedRecalls () {
			// Show a spinner so the user waits
			this.loadingDeleteSelectedRecalls = true;

			const me = this;

			var recallUuids;

			// If the recalls are from a consecutive day record study, all the recalls from that record
			// are deleted. The API only needs one uuid from that record number.
			if (this.selectedStudy.recordStudyType === this.$createStudyLists.RECORD_TYPE_CONSECUTIVE.value) {
				var tempRecallUuids = this.selected.slice();
				var recallsToSend = [];

				while (tempRecallUuids.length) {
					var item = tempRecallUuids.pop();

					for (var i = 0; i < tempRecallUuids.length; i++) {
						// Check for userName and recall number to be the same
						if (item.userName === tempRecallUuids[i].userName && item.recordNo === tempRecallUuids[i].recordNo) {
							tempRecallUuids.splice(i, 1);
							i--;
						}
					}
					recallsToSend.push(item);
				}

				recallUuids = recallsToSend.map(i => i.recallId);
			} else {
				recallUuids = this.selected.map(i => i.recallId);
			}

			researcherApiService.deleteRecalls(this.studyUuid, recallUuids)
				.then(response => {
					if (response.status >= 200 && response.status < 300) {
						// After delete reload the data. Wait for 2 seconds so the data store propogates the deletion
						setTimeout(() => {
							me.loadData().then(() => {
								// Only cleanup the spinners once the data has been reloaded

								// Cleanup the confirmation modal
								me.loadingDeleteSelectedRecalls = false;
								me.showDeleteSelectedRecallsModal = false;
								me.selected = [];

								// Show a success message
								me.$store.dispatch(
									'changeUpdateStatus',
									{ status: 'delete-recalls-success' }
								);
							})
						}, 3500);
					}
				})
				.catch(error => {
					// After a failed delete reload the data. Wait for 2 seconds so the data store propogates the deletion
					setTimeout(() => {
						me.loadData().then(() => {
							// Only cleanup the spinners once the data has been reloaded

							// Cleanup the confirmation modal
							me.loadingDeleteSelectedRecalls = false;
							me.showDeleteSelectedRecallsModal = false;
							me.selected = [];

							// Show an error message
							me.$store.dispatch('changeUpdateStatusWithMessage', {
								status: 'delete-recalls-fail',
								message: 'There was an error deleting the recalls'
							});
						})
					}, 3500);
				});
		},
		getFormattedDate (date) {
			if (date && date.length) {
				return utilityService.formatDate(date)
			}

			return 'N/A';
		},
		calculatePageCount (itemsPerPage) {
			const countRecalls = this.recallsResults.total ? this.recallsResults.total : 0;
			return Math.ceil(countRecalls / itemsPerPage);
		}
	}
}
</script>

<style>

</style>
